import { AxiosPromise } from 'axios';
import axios from 'axios';
import { IGetMembers, IGetMessage, IGetMessageRead, IGetReceivedMessages, IGetSentMessages, IGetUnreadMessages } from '../models/messages.model';

const uri = '/mgmt/messages';

export const getUnreadMessages = (): AxiosPromise<IGetUnreadMessages> => {
  return axios.get(`${uri}/not-read`);
};

export const archiveMessage = (messageCode: number): AxiosPromise => {
  return axios.put(`${uri}/move/storage-box/${messageCode}`);
};

export const getReceivedMessage = (messageCode: number): AxiosPromise<IGetMessage> => {
  return axios.get(`${uri}/recipient/detail/${messageCode}`);
};

export const getReceivedMessages = (): AxiosPromise<IGetReceivedMessages> => {
  return axios.get(`${uri}/recipient-list`);
};

export const deleteReceivedMessages = (data: number[]): AxiosPromise => {
  return axios.put(`${uri}/recipient/remove`, data);
};

export const getSentMessage = (messageCode: number): AxiosPromise<IGetMessage> => {
  return axios.get(`${uri}/send/detail/${messageCode}`);
};

export const getSentMessages = (): AxiosPromise<IGetSentMessages> => {
  return axios.get(`${uri}/send-list`);
};

export const deleteSentMessages = (data: number[]): AxiosPromise => {
  return axios.put(`${uri}/send/remove`, data);
};

export const getArchivedMessage = (messageCode: number): AxiosPromise<IGetMessage> => {
  return axios.get(`${uri}/storage-box/${messageCode}`);
};

export const getArchivedMessages = (): AxiosPromise<IGetReceivedMessages> => {
  return axios.get(`${uri}/storage-box`);
};

export const getMembers = (): AxiosPromise<IGetMembers> => {
  return axios.get(`${uri}/search/member-list`);
};

export const createMessage = (data: any): AxiosPromise => {
  return axios.post(`${uri}/send`, data);
};

export const forwardMessage = (messageCode: number, data: any): AxiosPromise => {
  return axios.post(`${uri}/delivery/${messageCode}`, data);
};

export const getMessageRead = (messageCode: number): AxiosPromise<IGetMessageRead> => {
  return axios.get(`${uri}/read-list/${messageCode}`);
};
